<div [ngClass]="{
  'd-inline-block': isInline, 
  'd-flex justify-content-center align-items-center': !isInline, 'overlay': overlay}">
  <div class="loader" [ngClass]="shouldAnimate ? 'loader-spin': ''" [style.--dot-size]="dotSize" [style.--loader-size]="loaderSize" [style.--dot-color]="dotColor">
  </div>
</div>
